import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  addPlusIcon: {
    color: theme.palette.primary.main,
  },
  removePlusIcon: {
    color: theme.palette.error.main,
  },
  addPlusIconDisabled: {
    color: 'gray',
  },
}));

const TenantReservedSpots = ({
  register,
  fieldErrors,
  reservedSpots,
  isEditMode,
  getValues,
  setValue,
}) => {
  const [reservedSpotsCount, setReservedSpotsCount] = useState([]);
  const rules = useSelector((state) => state.rules);
  const classes = useStyles();
  const { allow_tenant_to_own_reserved_spots } = rules;

  const handleAddSpot = () => {
    setReservedSpotsCount([...reservedSpotsCount, 'ok']);
  };

  const handleRemoveSpot = (index) => {
    const count = reservedSpotsCount.filter((_, i) => i !== index);
    const data = getValues();
    if (data.reserved_spots.length === 0 || count.length === 0) {
      setValue('reserved_spots', [{ id: '', spot: '' }]);
      setReservedSpotsCount(['ok']);
      return;
    }
    setReservedSpotsCount(count);
    setValue(
      'reserved_spots',
      index === 0
        ? [...data.reserved_spots.slice(1)]
        : [
            ...data.reserved_spots.slice(0, index),
            ...data.reserved_spots.slice(index + 1),
          ].filter((value) => value.spot)
    );
  };

  useEffect(() => {
    setReservedSpotsCount(
      reservedSpots.length > 0 ? reservedSpots.map(() => 'ok') : ['ok']
    );
  }, [allow_tenant_to_own_reserved_spots, reservedSpots]);

  if (!allow_tenant_to_own_reserved_spots) {
    return null;
  }

  if (!reservedSpotsCount.length) {
    return null;
  }

  return reservedSpotsCount.map((item, index) => (
    <Grid item key={index} xs={12} md={4}>
      <Box display="flex" alignItems="center">
        <Box mr={5}>
          <Typography variant="subtitle2" color="primary">
            Reserved Spot:
          </Typography>
        </Box>
        <TextField
          name={`reserved_spots[${index}].id`}
          defaultValue={reservedSpots[index] ? reservedSpots[index].id : ''}
          size="small"
          style={{ display: 'none' }}
          inputRef={register}
        />
        <TextField
          name={`reserved_spots[${index}].spot`}
          size="small"
          defaultValue={reservedSpots[index] ? reservedSpots[index].spot : ''}
          disabled={!isEditMode}
          inputRef={register}
          error={!!fieldErrors.reserved_spots?.[index]}
          InputProps={{
            endAdornment: isEditMode ? (
              <InputAdornment>
                <IconButton
                  aria-label="Remove reserved spot"
                  onClick={() => handleRemoveSpot(index)}
                  edge="end"
                >
                  <CancelRoundedIcon
                    fontSize="small"
                    className={
                      isEditMode
                        ? classes.removePlusIcon
                        : classes.addPlusIconDisabled
                    }
                  />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
          autoComplete="off"
          helperText={
            fieldErrors.reserved_spots?.[index]
              ? fieldErrors.reserved_spots?.[index]
              : null
          }
          style={{ maxWidth: '40%' }}
        />
        {index === reservedSpotsCount.length - 1 && (
          <Box justifySelf="center">
            <Button
              type="button"
              disabled={!isEditMode}
              onClick={handleAddSpot}
            >
              <AddCircleIcon
                className={
                  isEditMode
                    ? classes.addPlusIcon
                    : classes.addPlusIconDisabled
                }
              />
            </Button>
          </Box>
        )}
      </Box>
    </Grid>
  ));
};

export default TenantReservedSpots;
